<template>
  <div class="page-wrapper">
    <div class="content container-fluid">

      <!-- Header -->
      <div class="page-header border-0 py-3 px-3 rounded shadow-sm bg-white">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title mb-1 d-flex align-items-center">
              <i class="fa fa-magic mr-2"></i> Viết bài hàng loạt
            </h3>
            <ul class="breadcrumb mb-0">
              <li class="breadcrumb-item"><a href="/">Dashboard</a></li>
              <li class="breadcrumb-item active">Viết bài hàng loạt</li>
            </ul>
          </div>
          <div class="col-auto d-none d-md-block">
            <span class="text-muted small">Meta: </span>
            <span class="badge badge-primary mr-2" v-if="idNguoiDung">ID: {{ idNguoiDung }}</span>
            <span class="badge badge-light" v-if="username">@{{ username }}</span>
          </div>
        </div>
      </div>

      <!-- Alert loading user meta -->
      <div v-if="userMetaLoading" class="alert alert-info d-flex align-items-center mt-3">
        <i class="fa fa-spinner fa-spin mr-2"></i>
        <div>Đang xác thực người dùng & lấy <b>idNguoiDung</b>…</div>
      </div>

      <div class="row mt-3">
        <!-- LEFT: Form -->
        <div class="col-lg-8 mb-3">
          <div class="card shadow-sm border-0">
            <div class="card-header bg-white d-flex align-items-center justify-content-between">
              <h5 class="card-title mb-0">
                <i class="fa fa-edit mr-2"></i> Cấu hình nội dung
              </h5>
              <small class="text-muted">Điền thông tin rồi bấm <b>Tiến hành</b></small>
            </div>

            <div class="card-body">
              <!-- ⚠️ BỌC BẰNG FORM -->
              <form @submit.prevent="handleSubmit" novalidate>
                <!-- KEYWORDS -->
                <div class="form-group">
                  <label class="font-weight-600 d-flex align-items-center">
                    <i class="fa fa-key mr-2"></i> Danh sách từ khóa
                    <span class="ml-auto small text-muted" v-if="(keywords || '').trim().length">
                      {{ (keywords || '').split(/[,\n]+/).map(k => k.trim()).filter(k => k).length }} từ khóa
                    </span>
                  </label>
                  <div class="input-group">
                    <div class="input-group-prepend d-none d-sm-flex">
                      <span class="input-group-text">
                        <i class="fa fa-list-ul"></i>
                      </span>
                    </div>
                    <textarea
                      rows="5"
                      class="form-control"
                      placeholder="Mỗi từ khóa phân tách bằng dấu phẩy hoặc xuống dòng"
                      v-model="keywords"
                      :disabled="submitting"
                    ></textarea>
                  </div>
                  <!-- Chips preview -->
                  <div class="mt-2" v-if="(keywords || '').trim().length">
                    <span
                      class="badge badge-pill badge-secondary mr-1 mb-1"
                      v-for="(k, idx) in (keywords || '').split(/[,\n]+/).map(x => x.trim()).filter(x => x).slice(0, 8)"
                      :key="idx"
                    >
                      {{ k }}
                    </span>
                    <span
                      v-if="(keywords || '').split(/[,\n]+/).map(x => x.trim()).filter(x => x).length > 8"
                      class="badge badge-light"
                    >
                      +{{ (keywords || '').split(/[,\n]+/).map(x => x.trim()).filter(x => x).length - 8 }} nữa
                    </span>
                  </div>
                </div>

                <!-- WEBSITE & CONTEXT -->
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label class="font-weight-600"><i class="fa fa-globe mr-2"></i> Link website</label>
                    <div class="input-group">
                      <div class="input-group-prepend d-none d-sm-flex">
                        <span class="input-group-text"><i class="fa fa-link"></i></span>
                      </div>
                      <!-- ép kiểu số -->
                      <select class="custom-select select" v-model.number="selectedWebsiteId" :disabled="loading || submitting">
                        <option :value="null" disabled>Chọn website</option>
                        <option v-for="site in websites" :key="site.id" :value="site.id">
                          {{ site.name }} ({{ site.baseUrl }})
                        </option>
                      </select>
                    </div>
                    <small class="form-text text-muted">Nơi sẽ đăng bài.</small>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="font-weight-600"><i class="fa fa-sitemap mr-2"></i> Ngữ cảnh bài viết</label>
                    <div class="input-group">
                      <div class="input-group-prepend d-none d-sm-flex">
                        <span class="input-group-text"><i class="fa fa-tag"></i></span>
                      </div>
                      <select class="custom-select select" v-model="context" :disabled="submitting">
                        <option value="" disabled>Chọn ngữ cảnh</option>
                        <option value="Article (Bài viết)">Article (Bài viết)</option>
                        <option value="Book (Sách)">Book (Sách)</option>
                        <option value="Course (Khóa học)">Course (Khóa học)</option>
                        <option value="Dataset (Bộ dữ liệu)">Dataset (Bộ dữ liệu)</option>
                        <option value="Event (Sự kiện)">Event (Sự kiện)</option>
                        <option value="FAQ (Câu hỏi thường gặp)">FAQ (Câu hỏi thường gặp)</option>
                        <option value="FactCheck (Kiểm tra thực tế)">FactCheck (Kiểm tra thực tế)</option>
                        <option value="HowTo (Hướng dẫn)">HowTo (Hướng dẫn)</option>
                        <option value="JobPosting (Tin tuyển dụng)">Job Posting (Tin tuyển dụng)</option>
                        <option value="Movie (Phim)">Movie (Phim)</option>
                        <option value="Music (Âm nhạc)">Music (Âm nhạc)</option>
                        <option value="Person (Người)">Person (Người)</option>
                        <option value="Product (Sản phẩm)">Product (Sản phẩm)</option>
                        <option value="Recipe (Công thức nấu ăn)">Recipe (Công thức nấu ăn)</option>
                        <option value="Restaurant (Nhà hàng)">Restaurant (Nhà hàng)</option>
                        <option value="Service (Dịch vụ)">Service (Dịch vụ)</option>
                        <option value="Software (Phần mềm)">Software (Phần mềm)</option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- CTA & LANGUAGE -->
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label class="font-weight-600"><i class="fa fa-bullhorn mr-2"></i> CTA</label>
                    <div class="input-group">
                      <div class="input-group-prepend d-none d-sm-flex">
                        <span class="input-group-text"><i class="fa fa-bullseye"></i></span>
                      </div>
                      <!-- ép kiểu số -->
                      <select class="custom-select select" v-model.number="selectedCtaId" :disabled="loading || submitting">
                        <option :value="null" disabled>Chọn CTA</option>
                        <option v-for="cta in ctas" :key="cta.id" :value="cta.id">
                          {{ cta.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="font-weight-600"><i class="fa fa-language mr-2"></i> Ngôn ngữ</label>
                    <div class="input-group">
                      <div class="input-group-prepend d-none d-sm-flex">
                        <span class="input-group-text"><i class="fa fa-comments"></i></span>
                      </div>
                      <select class="custom-select select" v-model="language" :disabled="submitting">
                        <option value="Tiếng Việt">Tiếng Việt</option>
                        <option value="English">English</option>
                        <option value="Tiếng Trung Quốc">Tiếng Trung Quốc</option>
                        <option value="Tiếng Nhật">Tiếng Nhật</option>
                        <option value="Tiếng Hàn Quốc">Tiếng Hàn Quốc</option>
                        <option value="Tiếng Pháp">Tiếng Pháp</option>
                        <option value="Tiếng Đức">Tiếng Đức</option>
                        <option value="Tiếng Tây Ban Nha">Tiếng Tây Ban Nha</option>
                        <option value="Tiếng Nga">Tiếng Nga</option>
                        <option value="Tiếng Bồ Đào Nha">Tiếng Bồ Đào Nha</option>
                        <option value="Tiếng Ý">Tiếng Ý</option>
                        <option value="Tiếng Ả Rập">Tiếng Ả Rập</option>
                        <option value="Tiếng Thổ Nhĩ Kỳ">Tiếng Thổ Nhĩ Kỳ</option>
                        <option value="Tiếng Hà Lan">Tiếng Hà Lan</option>
                        <option value="Campuchia">Campuchia</option>
                        <option value="Lào">Lào</option>
                        <option value="Thái Lan">Thái Lan</option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- Actions -->
                <div class="d-flex align-items-center justify-content-between mt-3">
                  <div class="text-muted small">
                    <i class="fa fa-info-circle mr-1"></i>
                    Nhấn <b>Tiến hành</b> để gửi cấu hình sang n8n.
                  </div>
                  <div>
                    <button type="submit" class="btn btn-primary" :disabled="submitting || !isFormValid">
                      <i v-if="!submitting" class="fa fa-paper-plane mr-1"></i>
                      <i v-else class="fa fa-spinner fa-spin mr-1"></i>
                      {{ submitting ? "Đang gửi..." : "Tiến hành" }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- RIGHT: Summary -->
        <div class="col-lg-4 mb-3">
          <!-- Tóm tắt -->
          <div class="card shadow-sm border-0 mb-3">
            <div class="card-header bg-white">
              <h6 class="mb-0 d-flex align-items-center">
                <i class="fa fa-eye mr-2"></i> Tóm tắt
              </h6>
            </div>
            <div class="card-body p-0">
              <ul class="list-group list-group-flush">
                <li class="list-group-item d-flex justify-content-between">
                  <span>Keywords</span>
                  <span class="badge badge-secondary">
                    {{ (keywords || '').split(/[,\n]+/).map(k=>k.trim()).filter(k=>k).length }}
                  </span>
                </li>
                <li class="list-group-item">
                  <div class="text-muted small mb-1">Website</div>
                  <div v-if="selectedWebsiteId != null">
                    <span class="badge badge-pill badge-primary">
                      {{ (websites.find(s => s.id === selectedWebsiteId) || {}).name || '—' }}
                    </span>
                    <div class="small text-muted">
                      {{ (websites.find(s => s.id === selectedWebsiteId) || {}).baseUrl || '' }}
                    </div>
                  </div>
                  <div v-else class="text-muted">Chưa chọn</div>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <span>Ngữ cảnh</span>
                  <span class="badge badge-light">{{ context || '—' }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <span>CTA</span>
                  <span class="badge badge-info">
                    {{ (ctas.find(c => c.id === selectedCtaId) || {}).name || '—' }}
                  </span>
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <span>Ngôn ngữ</span>
                  <span class="badge badge-dark">{{ language }}</span>
                </li>
              </ul>
            </div>
          </div>

          <!-- Người thực hiện -->
          <div class="card shadow-sm border-0">
            <div class="card-header bg-white">
              <h6 class="mb-0 d-flex align-items-center">
                <i class="fa fa-user-check mr-2"></i> Người thực hiện
              </h6>
            </div>
            <div class="card-body">
              <div class="d-flex align-items-center mb-2">
                <span class="text-muted small mr-2" style="min-width:90px">ID</span>
                <span class="badge badge-primary px-2">{{ idNguoiDung || '—' }}</span>
              </div>
              <div class="d-flex align-items-center mb-2">
                <span class="text-muted small mr-2" style="min-width:90px">Username</span>
                <span class="badge badge-light px-2">{{ username || '—' }}</span>
              </div>
              <div class="d-flex align-items-center">
                <span class="text-muted small mr-2" style="min-width:90px">Token</span>
                <code class="small mb-0 text-truncate d-inline-block" style="max-width: 220px;">
                  {{ (accessToken || '').slice(0,16) }}…{{ (accessToken || '').slice(-10) }}
                </code>
              </div>
              <small class="text-muted d-block mt-2">
                Header <code>Authorization: Bearer …</code> sẽ tự gắn nhờ interceptor.
              </small>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import api from "../api";
import { useToast } from "vue-toastification";

// ====== State ======
const keywords = ref("");
const selectedWebsiteId = ref(null); // ép số
const context = ref("");
const selectedCtaId = ref(null);     // ép số
const language = ref("Tiếng Việt");

const websites = ref([]);
const ctas = ref([]);
const loading = ref(true);
const submitting = ref(false);

const toast = useToast();

// n8n webhook
const n8nWebhookUrl = "https://n8n.thepminhtien.com/webhook/3d2c7fec-2d24-4082-8217-9d1a35826262";

// ===== Helpers (JWT) =====
function getToken() {
  return (
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken") ||
    null
  );
}

function base64UrlDecode(str) {
  try {
    const pad = "=".repeat((4 - (str.length % 4)) % 4);
    const base64 = (str + pad).replace(/-/g, "+").replace(/_/g, "/");
    const decoded = atob(base64);
    try {
      return decodeURIComponent(
        decoded
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
    } catch {
      return decoded;
    }
  } catch {
    return "";
  }
}

function parseJwt(token) {
  try {
    const payload = token.split(".")[1];
    return JSON.parse(base64UrlDecode(payload) || "{}");
  } catch {
    return {};
  }
}

// user meta cho n8n
const userMetaLoading = ref(false);
const accessToken = ref("");
const username = ref(null);
const idNguoiDung = ref(null);

// Ưu tiên id trong JWT, fallback theo username
async function ensureUserMeta() {
  if (idNguoiDung.value && accessToken.value) return;

  userMetaLoading.value = true;
  try {
    accessToken.value = getToken();
    if (!accessToken.value) throw new Error("Không tìm thấy access_token. Vui lòng đăng nhập lại.");

    const claims = parseJwt(accessToken.value);

    const idFromToken =
      claims.idNguoiDung ??
      claims.userId ??
      claims.id ??
      (Number.isInteger(claims.sub) ? claims.sub : null);

    username.value =
      claims.tenDangNhap ??
      claims.username ??
      (typeof claims.sub === "string" ? claims.sub : null);

    if (idFromToken) {
      try {
        const { data } = await api.get(`/api/nguoi-dung/${idFromToken}`);
        const id = data?.data?.idNguoiDung ?? data?.data?.id ?? data?.idNguoiDung ?? data?.id;
        if (id != null) idNguoiDung.value = Number(id);
      } catch {}
    }

    if (idNguoiDung.value == null && username.value) {
      const { data } = await api.get("/api/nguoi-dung", {
        params: { keyword: username.value, page: 0, size: 1 },
      });
      const item = data?.data?.content?.[0];
      const id = item?.idNguoiDung ?? item?.id;
      if (id != null) idNguoiDung.value = Number(id);
    }

    if (idNguoiDung.value == null) {
      throw new Error("Không xác định được idNguoiDung từ JWT/username.");
    }
  } finally {
    userMetaLoading.value = false;
  }
}

// ===== fetch lists =====
const fetchCtas = async () => {
  try {
    const response = await api.get("/api/ctas");
    if (response.data && response.data.content) {
      ctas.value = response.data.content;
    } else if (Array.isArray(response.data)) {
      ctas.value = response.data;
    }
  } catch (error) {
    console.error("Lỗi khi tải danh sách CTA:", error);
    toast.error("Lỗi khi tải danh sách CTA.");
  }
};

const fetchWebsites = async () => {
  try {
    const response = await api.get("/api/wp-sites");
    if (response.data && response.data.content) {
      websites.value = response.data.content;
    } else if (Array.isArray(response.data)) {
      websites.value = response.data;
    }
  } catch (error) {
    console.error("Lỗi khi tải danh sách website:", error);
    toast.error("Lỗi khi tải danh sách website.");
  }
};

onMounted(async () => {
  loading.value = true;
  await Promise.all([fetchWebsites(), fetchCtas()]);
  await ensureUserMeta();
  loading.value = false;
});

// ===== validate =====
const isFormValid = computed(() => {
  const kwCount = (keywords.value || "")
    .split(/[,\n]+/)
    .map((s) => s.trim())
    .filter(Boolean).length;
  return kwCount > 0 &&
    selectedWebsiteId.value != null &&
    selectedCtaId.value != null &&
    (context.value || "").length > 0;
});

// ===== submit =====
const handleSubmit = async () => {
  if (!isFormValid.value) {
    toast.error("Vui lòng điền đầy đủ thông tin cần thiết.");
    return;
  }
  if (submitting.value) return;
  submitting.value = true;

  try {
    await ensureUserMeta();

    const selectedWebsite = websites.value.find((site) => site.id === selectedWebsiteId.value) || null;
    const selectedCta = ctas.value.find((cta) => cta.id === selectedCtaId.value) || null;

    const formData = {
      keywords: (keywords.value || "")
        .split(/[,\n]+/)
        .map((k) => k.trim())
        .filter(Boolean),
      website: selectedWebsite,
      context: context.value,
      cta: selectedCta,
      language: language.value,
      meta: {
        idNguoiDung: idNguoiDung.value,
        username: username.value || null,
        accessToken: accessToken.value || null,
        tokenType: "Bearer",
        time: new Date().toISOString(),
        source: "content-crm-fe-bulk-create",
      },
    };

    console.log("👉 Sending to n8n:", n8nWebhookUrl, formData);

    await api.post(n8nWebhookUrl, formData, {
      headers: {
        "X-User-Id": String(idNguoiDung.value ?? ""),
        "X-Username": username.value ?? "",
      },
    });

    toast.success("Đã gửi thành công đến n8n!");
  } catch (error) {
    console.error("Lỗi khi gửi đến n8n:", error);
    const msg =
      error?.response?.data?.message ||
      (error?.message?.includes("Network Error") ? "Network/CORS error" : error?.message) ||
      "Gửi dữ liệu thất bại. Kiểm tra webhook URL / CORS.";
    toast.error(msg);
  } finally {
    submitting.value = false;
  }
};
</script>

<style scoped>
.font-weight-600 { font-weight: 600; }
.card { border-radius: .6rem; }
.card-header { border-bottom: 1px solid #f2f2f2; }
.page-header { border-radius: .6rem; }
.badge-pill { padding: .4rem .6rem; }
.input-group-text { background: #f8f9fa; }
.list-group-item { padding: .75rem 1rem; }
textarea.form-control { min-height: 130px; }
</style>
